export default "__VITE_ASSET__D94x0Q06__"